"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guid = void 0;
function guid() {
    return Math.random().toString(36).slice(2);
}
exports.guid = guid;
